
import React, { forwardRef, useImperativeHandle } from 'react';
import { Form, Input, Button, Row, Col, DatePicker } from 'antd';
// import { statusIndexToText } from '../statusConfig';
import { formItemLayout } from '../../../util/formItemLayoutConfig';
import './searchForm.less';

const { RangePicker } = DatePicker;
// const { Option } = Select;

export const SearchForm = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const onFinish = () => {
    props.searchFn();
  };
  const reset = () => {
    form.resetFields();
    props.searchFn();
  };

  useImperativeHandle(ref, () => ({ form }));

  return (
    <div className='search-form-container'>
      <Form form={form} name="order-form" {...formItemLayout} onFinish={onFinish}>
        <Row>
          <Col span={8}>
            <Form.Item name="out_order_no" label='退货单号：' className='search-form-label'>
              <Input placeholder="退货单号" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="dateRange" label='退货申请日期：' className='search-form-label'>
              <RangePicker format="YYYY-MM-DD" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="receiver_name" label='供应商名称：' className='search-form-label' >
              <Input placeholder="供应商名称" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="sku_name" label='商品名称：' className='search-form-label'>
              <Input placeholder="商品名称" />
            </Form.Item>
          </Col>
          <Col span={2} offset={14}>
            <Form.Item wrapperCol={{ span: 24 }}>
              <div className='search-form-btn-container'>
                <Button type='primary' className='search-form-btn' htmlType="submit"> 查询 </Button>
                <Button type='default' className='search-form-btn' htmlType="button" style={{ marginLeft: 20 }} onClick={reset}> 重置 </Button>
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div >
  );
});
